import { Icons } from "../../Components/Icons/Icons";

interface DashboardHeaderProps {
  onFilterChange: (status: string) => void;
  onSearchChange: (query: string) => void;
  searchQuery: string;
}

export const DashboardHeader = ({ onFilterChange, onSearchChange, searchQuery }: DashboardHeaderProps) => (
  <header className="dashboard-header">
    <div className="filter">
      <label className="search-input-container">
        {Icons.SearchIcon}
        <input 
          type="text" 
          placeholder="Search" 
          className="search-input" 
          value={searchQuery} 
          onChange={(e) => onSearchChange(e.target.value)} 
        />
      </label>
      <div className="status-filters">
        <label>
          <input 
            type="checkbox" 
            onChange={(e) => {
              onFilterChange("CONFIRMED");
              e.target.parentElement?.querySelector('.custom-checkbox')
                ?.classList.toggle('active', e.target.checked);
            }} 
          />
          <span className="custom-checkbox"></span>
          Confirmed
        </label>
        <label>
          <input 
            type="checkbox" 
            onChange={(e) => {
              onFilterChange("ACTIVE");
              e.target.parentElement?.querySelector('.custom-checkbox')
                ?.classList.toggle('active', e.target.checked);
            }} 
          />
          <span className="custom-checkbox"></span>
          Outstanding
        </label>
        <label>
          <input 
            type="checkbox" 
            onChange={(e) => {
              onFilterChange("DISPUTED");
              e.target.parentElement?.querySelector('.custom-checkbox')
                ?.classList.toggle('active', e.target.checked);
            }} 
          />
          <span className="custom-checkbox"></span>
          Disputed 
        </label>
      </div>
    </div>
  </header>
);